<template>
    <v-content>
        <v-breadcrumbs :items="items" large></v-breadcrumbs>
        <v-row>
            <v-col cols="12">
                <v-row justify="start">
                    <v-col
                        cols="12"
                        sm="4"
                        md="3"
                        xl="2"
                            v-for="title in titles"
                            v-bind:key="title.link"
                            class="viewCard"
                    >
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <router-link :to="title.link">
                                    <v-card
                                            :elevation="10"
                                            class="main-color text-center"
                                            height="100"
                                            width="200"
                                    >
                                        <v-list-item three-line>
                                            <v-list-item-content>
                                                <v-list-item-title
                                                        class="white--text subtitle-1 mt-1 pa-4"
                                                >{{title.name}}</v-list-item-title>
                                                <v-list-item-subtitle class="white--text header-6 mt-1">
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-card>
                                </router-link>
                            </template>
                        </v-tooltip>
                    </v-col>

                    <v-col
                            cols="auto"
                            class="viewCard"
                    >
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <router-link to="HomeStayaAvailableRoom">
                                    <v-card
                                            :elevation="10"
                                            class="main-color text-center"
                                            height="100"
                                            width="200"
                                    >
                                        <v-list-item three-line>
                                            <v-list-item-content>
                                                <v-list-item-title
                                                        class="white--text subtitle-1 mt-1 pa-4"
                                                >Room</v-list-item-title>
                                                <v-list-item-subtitle class="white--text header-6">
                                                    Available : {{roomCount.availableCounts}}
                                                    Total : {{roomCount.totalCounts}}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-card>
                                </router-link>
                            </template>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-content>
</template>

<script>
    import axios from "axios";

    export default {
        name: "Dashboard",
        watch: {},
        components: {},
        data() {
            return {
                titles: [
                    {name:"Generate report",
                        link:"/report"},
                    {name:"Profile",
                        link:"/branch"},
                    {name:"Customer",
                        link:"/HomeStay"}
                ],
                items: [
                    {
                        text: "Dashboard",
                        disabled: true,
                        to: "/dashboard",
                        exact: true
                    }],
                branchInformation:[],
                roomCount:""
            }
        },
        mounted() {
            this.formData()
        },
        methods: {
            async formData() {
                const dashboardData = await axios.get(
                    "Branch/GetBranchInformationByBranchID"
                );
                this.branchInformation = dashboardData.data;

                const availableCount = await axios.get('Hotel/RoomStatusCountAsync',{params:{
                        ShowCount:true
                    }})
                this.roomCount = availableCount.data
            },
        }
    };
</script>

<style lang="scss" scoped>
    a{
        text-decoration: none;
    }
</style>
